import { render, staticRenderFns } from "./ItemCustomView.vue?vue&type=template&id=1a0e3c16&scoped=true&"
import script from "./ItemCustomView.vue?vue&type=script&lang=js&"
export * from "./ItemCustomView.vue?vue&type=script&lang=js&"
import style0 from "./ItemCustomView.vue?vue&type=style&index=0&id=1a0e3c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e3c16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VSheet})
